import { config } from 'api';

export const REFER_FRIEND_BETA_FEATURE = 'INVITE_A_FRIEND';

export const REFER_FRIEND_SCRIBE_BASE_URL = `${config.apiBasePath}/refer-a-friend-landing-pages`;

export const customerPageType = {
  existing: 'existing_customer',
  new: 'new_customer',
};
